import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemsByRoleComponent } from './menu-items-by-role.component';

const routes: Routes = [
  {
    path: '',
    component: MenuItemsByRoleComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuItemsByRoleRoutingModule { }
